import { createTheme } from '@mui/material';

const font = {
  regular: 'Open Sans',
  bold: 'Open Sans',
  medium: 'Open Sans',
  light: 'Open Sans',
};

export const theme = createTheme({
  direction: 'rtl',
  typography: {
    htmlFontSize: 10,
    fontFamily: font.regular,
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#053550',
      light: '#1E73A3',
    },
    error: {
      main: '#E42323',
    },
    background: {
      default: '#E9EBF0',
    },
    text: {
      primary: '#1E3761',
      hint: '#adb5bd',
      highlight: '#466ae8',
    },
  },
  breakpoints: {
    values: {
      xs: 0, // Required
      sm: 370, // like $media-mobile-small-ultra
      ms: 450, // mobile-small-max
      mm: 820, // max-mobile
      md: 1153, // tablet-max
      lg: 1531, // desktop-small-max
      xl: 1690, // desktop-medium
    },
  },
});

export default theme;
